import defaultPlans from 'data/plans'

const PLAN_KEYS = {
  A: { amount: 'planA', discount: 'discountA' },
  B: { amount: 'planB', discount: 'discountB' },
  C: { amount: 'planC', discount: 'discountC' },
}

/** Payable price = plan amount − discount (same rule on admin + frontend + payment). */
export function netPlanPrice(amount, discount) {
  return Math.max(0, Number(amount || 0) - Number(discount || 0))
}

export function resolveMembershipPlanPrice(fees, planLetter) {
  const keys = PLAN_KEYS[planLetter]
  if (!keys) return null

  if (fees && fees[keys.amount] != null && fees[keys.amount] !== '') {
    return netPlanPrice(fees[keys.amount], fees[keys.discount])
  }

  const fallback = defaultPlans.find(p => p.name === `Plan ${planLetter}`)
  if (!fallback) return null
  return netPlanPrice(fallback.price, fallback.discount)
}

export function formatPlanOptionLabel(durationLabel, fees, planLetter) {
  const price = resolveMembershipPlanPrice(fees, planLetter)
  return price != null ? `${durationLabel} — ₹${price}` : durationLabel
}
